export const escapeRegex = (string) => {
  return string.replace(/[-/\\^$*+?.()|[\]{}]/g, '\\$&'); // escape special characters (as in the case of $w or #w and so forth)
};

const getPatternLastMatchIndex = (type, pattern) => {
  const regex = new RegExp(pattern, 'g');
  const match = type.match(regex);
  if (match) {
    const lastMatch = match[match.length - 1];
    if (lastMatch.startsWith('.')) {
      return type.lastIndexOf(lastMatch) + 1;
    }
    return type.lastIndexOf(lastMatch);
  }
  return -1;
};

export const getLastOccurenceOfType = (type, typeToReplaceDisplayName) => {
  const escapedTypeToReplaceDisplayName = escapeRegex(typeToReplaceDisplayName);
  if (type.lastIndexOf(typeToReplaceDisplayName) === -1) {
    return -1;
  }

  /*
  The reason we check the patterns one by one is because one regex can't find overlapping matches.
  I.e. in the case of the "$w.$w" string, only one match will be found - the first match "$w." - and the last match
  will be missed (".$w").
   */
  const patternForEnd = `[.]${escapedTypeToReplaceDisplayName}$`;
  const indexOfEndRegex = getPatternLastMatchIndex(type, patternForEnd);
  if (indexOfEndRegex !== -1) {
    return indexOfEndRegex;
  }

  const patternForMiddle = `[.]${escapedTypeToReplaceDisplayName}[.]`;
  const indexOfMiddleRegex = getPatternLastMatchIndex(type, patternForMiddle);
  if (indexOfMiddleRegex !== -1) {
    return indexOfMiddleRegex;
  }

  const patternForStart = `^${escapedTypeToReplaceDisplayName}[.]`;
  const indexOfStartRegex = getPatternLastMatchIndex(type, patternForStart);
  if (indexOfStartRegex !== -1) {
    return indexOfStartRegex;
  }

  const patternForExact = `^${escapedTypeToReplaceDisplayName}$`;
  const indexOfExactRegex = getPatternLastMatchIndex(type, patternForExact);
  if (indexOfExactRegex !== -1) {
    return indexOfExactRegex;
  }

  return -1;
};
